import { render, staticRenderFns } from "./CorrectiveSamples.vue?vue&type=template&id=d73672e2&lang=pug&"
import script from "./CorrectiveSamples.vue?vue&type=script&lang=js&"
export * from "./CorrectiveSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports